var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import BaseBox from './BaseBox';
var handleSize = function (props) {
    var size = props.size;
    if (!size)
        return;
    if (typeof size === 'string')
        return "\n    width: " + size + ";\n    height: " + size + ";\n  ";
    return "\n    width: " + size + "px;\n    height: " + size + "px;\n  ";
};
var CenterBox = styled(BaseBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  place-items: center;\n  ", ";\n"], ["\n  display: grid;\n  place-items: center;\n  ", ";\n"])), function (props) { return handleSize(props); });
export default CenterBox;
var templateObject_1;
